export const AGENT_PRIVATE_CHAT_RESPONSE_TIMEOUT_MS = 8000;

export function clearAgentPeerResponseWatchdog(
  pendingPrompt,
  { clearTimeoutFn = clearTimeout } = {}
) {
  if (!pendingPrompt?.agentPeerResponseTimeoutId) {
    return;
  }

  clearTimeoutFn(pendingPrompt.agentPeerResponseTimeoutId);
  pendingPrompt.agentPeerResponseTimeoutId = undefined;
}

export function markAgentPeerResponseReceived(
  pendingPrompt,
  { clearTimeoutFn = clearTimeout } = {}
) {
  if (!pendingPrompt) {
    return;
  }

  pendingPrompt.hasAgentResponse = true;
  pendingPrompt.agentPeerResponseTimedOut = false;
  clearAgentPeerResponseWatchdog(pendingPrompt, { clearTimeoutFn });
}

export function startAgentPeerResponseWatchdog(
  pendingPrompt,
  {
    streamId,
    timeoutMs = AGENT_PRIVATE_CHAT_RESPONSE_TIMEOUT_MS,
    setTimeoutFn = setTimeout,
    clearTimeoutFn = clearTimeout,
    onTimeout
  } = {}
) {
  clearAgentPeerResponseWatchdog(pendingPrompt, { clearTimeoutFn });
  pendingPrompt.hasAgentResponse = false;
  pendingPrompt.agentPeerResponseTimedOut = false;
  pendingPrompt.agentPeerResponseTimeoutId = setTimeoutFn(() => {
    pendingPrompt.agentPeerResponseTimeoutId = undefined;

    if (pendingPrompt.hasAgentResponse || pendingPrompt.agentPeerResponseTimedOut) {
      return;
    }

    pendingPrompt.agentPeerResponseTimedOut = true;
    onTimeout?.({ streamId });
  }, timeoutMs);

  return pendingPrompt.agentPeerResponseTimeoutId;
}
